import "swiper/css";
import "swiper/css/navigation";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import endpoints from "../../config/endpoints";
import { setLoading } from "../../services/reducers/homeSlice";
import { fetchProfile } from "../../services/reducers/userSlice";
import restApi from "../../services/restApi";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  const send = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.login).post({
      username: username,
      password: password,
    });

    dispatch(setLoading(false));
    if (res.code == 200) {
      Cookies.set("token", res.data.token);
      navigate("/order/");
      dispatch(fetchProfile());
    }
  };

  useEffect(() => {
    if (Cookies.get("token")) {
      navigate("/order");
    }
  }, []);

  return (
    <section className="loginPage">
      <div className="loginForm">
        <div className="loginHeader">
          {/*<img src="/img/logo.png" />*/}
          <h2 className="headerTitle">Parsian LED</h2>
        </div>
        <div>
          <div className="loginRow">
            <label>نام کاربری</label>
            <input
              type="text"
              placeholder="نام کاربری"
              onChange={(input: any) => setUsername(input.target.value)}
            />
          </div>
          <div className="loginRow">
            <label>رمز عبور</label>
            <input
              type="password"
              placeholder="رمز عبور"
              onChange={(input: any) => setPassword(input.target.value)}
            />
          </div>
          <div className="loginRow">
            <button onClick={send}>ورود</button>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Login;
